/* ==========================================================================
   Lovelle — grace.js (Lovelle Grace minimizer bra, product.grace.json)
   Loaded only on that template, after bra.js (both deferred, in that order).
   bra.js already owns the packs, the per-bra <select>s, the chips it draws
   over the colour selects (data-bra-chips), the hidden size pills, the
   add-to-cart, reviews and lightbox. This file adds:

   1. (Colour is chosen per bra in a dropdown inside the packs, as on Lovelle
      Skin; bra.js draws it. The colour cards further down still set every bra.)
      Legacy: a colour block above the packs: one tap puts that colour on every bra
      in every pack, turns the gallery to its photo and updates the line
      under the buttons. Arrow keys move between colours.
   2. The size block: band (70–105) then cup (B–H). Both chosen = one size,
      handed to bra.js (LovelleBraSetSize) so every bra in every pack follows.
      Nothing is preselected; until a size is chosen the add-to-cart and the
      sticky bar take the shopper to the size block instead of guessing.
   3. "Different sizes in the pack": adds a size dropdown to every bra row
      (bra.js data-bra-mixed-sizes); turning it off puts every bra back on
      the size chosen above. Colours stay as picked.
   4. A one-line receipt above the button ("4 BH · 80E · 2× Svart, 2× Beige").
   5. The sticky bar follows the chosen pack (name + total) and adds it.
   6. The size guide dialog with its calculator, which can apply its answer.
   7. "Pick this colour" cards further down, the before / after slider and
      smooth in-page links under the sticky header.

   No user-facing string is written here; every word is already in the DOM.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-gr-root]');
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function headerOffset() {
    var h = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10);
    return (isNaN(h) ? 64 : h) + 14;
  }
  function scrollToEl(el) {
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: y, behavior: reduced ? 'auto' : 'smooth' });
  }
  function flash(el) {
    if (!el) return;
    el.classList.remove('is-flash');
    void el.offsetWidth;
    el.classList.add('is-flash');
  }

  /* ---- 7: in-page links (stars under the title, "see all reviews") ---- */
  qsa('[data-gr-scroll]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = qs(a.getAttribute('data-gr-scroll'));
      if (!target) return;
      e.preventDefault();
      scrollToEl(target);
      if (history.replaceState) history.replaceState(null, '', a.getAttribute('data-gr-scroll'));
    });
  });

  /* ---- 7: photo with numbered details ---- */
  qsa('[data-gr-spots]').forEach(function (root) {
    var dots = qsa('[data-gr-spot]', root);
    var panels = qsa('[data-gr-spot-panel]', root);
    if (!dots.length) return;
    function show(i) {
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); d.setAttribute('aria-pressed', n === i ? 'true' : 'false'); });
      panels.forEach(function (p, n) { p.classList.toggle('is-active', n === i); });
    }
    dots.forEach(function (d, n) { d.addEventListener('click', function () { show(n); }); });
    root.classList.add('is-ready');
  });

  /* ---- 6: size guide dialog + calculator (works on every section) ---- */
  var guide = qs('[data-gr-guide]');
  var lastOpener = null;
  function openGuide(opener) {
    if (!guide) return;
    lastOpener = opener || null;
    if (typeof guide.showModal === 'function') { if (!guide.open) guide.showModal(); }
    else guide.setAttribute('open', '');
    document.documentElement.classList.add('gr-guide-open');
  }
  function closeGuide() {
    if (!guide) return;
    guide.classList.add('is-closing');
    setTimeout(function () {
      guide.classList.remove('is-closing');
      if (typeof guide.close === 'function' && guide.open) guide.close();
      else guide.removeAttribute('open');
      document.documentElement.classList.remove('gr-guide-open');
      if (lastOpener && lastOpener.focus) lastOpener.focus({ preventScroll: true });
    }, reduced ? 0 : 200);
  }
  qsa('[data-gr-guide-open]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); openGuide(b); });
  });
  if (guide) {
    qsa('[data-gr-guide-close]', guide).forEach(function (b) { b.addEventListener('click', closeGuide); });
    guide.addEventListener('click', function (e) { if (e.target === guide) closeGuide(); });
    guide.addEventListener('cancel', function (e) { e.preventDefault(); closeGuide(); });
  }

  /* The chart: band = underbust to the nearest five (70–105),
     cup = overbust − underbust: B 7–9, C 9–11 … H 19–21 cm. */
  var CUPS = ['B', 'C', 'D', 'E', 'F', 'G', 'H'];
  function sizeFor(under, over) {
    var band = Math.round(under / 5) * 5;
    var diff = over - under;
    if (band < 70 || band > 105 || diff < 7 || diff > 21) return null;
    var i = Math.min(6, Math.max(0, Math.floor((diff - 7) / 2)));
    return { band: String(band), cup: CUPS[i] };
  }
  qsa('[data-gr-calc]').forEach(function (form) {
    var under = qs('[data-gr-under]', form);
    var over = qs('[data-gr-over]', form);
    var res = qs('[data-gr-calc-res]', form);
    var sizeEl = qs('[data-gr-calc-size]', form);
    var use = qs('[data-gr-calc-use]', form);
    var msg = qs('[data-gr-calc-msg]', form);
    var current = null;
    function run() {
      var u = parseFloat(under.value), o = parseFloat(over.value);
      current = null;
      if (!u || !o) {
        res.hidden = true; use.hidden = true;
        msg.textContent = (under.value || over.value) ? form.getAttribute('data-msg-empty') : '';
        msg.hidden = !msg.textContent;
        return;
      }
      var s = sizeFor(u, o);
      if (!s) {
        res.hidden = true; use.hidden = true;
        msg.textContent = form.getAttribute('data-msg-out');
        msg.hidden = false;
        return;
      }
      current = s;
      msg.hidden = true;
      sizeEl.textContent = s.band + s.cup;
      res.hidden = false;
      res.classList.remove('is-new'); void res.offsetWidth; res.classList.add('is-new');
      if (window.GraceSetSize) {
        use.textContent = (form.getAttribute('data-use') || '').replace('{size}', s.band + s.cup);
        use.hidden = false;
      }
    }
    form.addEventListener('input', run);
    form.addEventListener('submit', function (e) { e.preventDefault(); run(); });
    use.addEventListener('click', function () {
      if (!current || !window.GraceSetSize) return;
      window.GraceSetSize(current.band, current.cup);
      if (guide && guide.contains(form)) closeGuide();
      setTimeout(function () {
        var block = qs('[data-gr-size]');
        scrollToEl(block);
        flash(block);
      }, reduced ? 0 : 220);
    });
  });

  if (!root) return;
  var bundle = qs('[data-bra-bundle]', root);
  if (!bundle) return;

  var product = null;
  try { product = JSON.parse(qs('[data-bra-product-json]', root).textContent); } catch (e) { product = null; }
  var colourPos = parseInt(bundle.getAttribute('data-color-pos'), 10) || 0;

  /* ---- Sold-out colours ---- */
  var soldOut = [];
  if (product && product.variants && colourPos) {
    var anyAvailable = {};
    var all = [];
    product.variants.forEach(function (v) {
      var c = v.options[colourPos - 1];
      if (all.indexOf(c) < 0) all.push(c);
      if (v.available !== false) anyAvailable[c] = true;
    });
    all.forEach(function (c) { if (!anyAvailable[c]) soldOut.push(c); });
  }

  var selects = qsa('select[data-bra-color]', bundle);
  var sizeSelects = qsa('select[data-bra-size]', bundle);
  var block = qs('[data-gr-colour]', root);
  var swatches = block ? qsa('[data-gr-swatch]', block) : [];
  var currentEl = block ? qs('[data-gr-colour-current]', block) : null;
  var hintEl = block ? qs('[data-gr-colour-hint]', block) : null;
  var mix = qs('[data-gr-mix]', bundle);
  var globalColour = null;

  function labelOf(value) {
    var sw = swatches.filter(function (s) { return s.getAttribute('data-value') === value; })[0];
    return sw ? (sw.getAttribute('data-label') || value) : value;
  }

  /* ---- paint the chips bra.js drew, and the name beside each row ---- */
  selects.forEach(function (sel) {
    var chips = sel.parentNode.querySelector('.brachips');
    if (!chips) return;
    qsa('.brachips__opt', chips).forEach(function (btn) {
      var value = btn.getAttribute('data-value');
      var opt = Array.prototype.filter.call(sel.options, function (o) { return o.value === value; })[0];
      var dot = btn.querySelector('.brachips__dot');
      if (opt && dot && opt.getAttribute('data-hex')) dot.style.background = opt.getAttribute('data-hex');
      if (soldOut.indexOf(value) > -1) {
        btn.setAttribute('data-oos', 'true');
        btn.setAttribute('aria-disabled', 'true');
      }
    });
  });
  function paintRow(sel) {
    var pick = sel.closest('[data-bra-pick]');
    var name = pick ? pick.querySelector('[data-gr-pick-name]') : null;
    if (name) name.textContent = labelOf(sel.value);
  }
  selects.forEach(paintRow);

  /* ---- 1: the colour block ---- */
  swatches.forEach(function (sw) {
    if (soldOut.indexOf(sw.getAttribute('data-value')) > -1) {
      sw.setAttribute('data-oos', 'true');
      sw.setAttribute('aria-disabled', 'true');
    }
  });

  function paintBlock(value) {
    swatches.forEach(function (sw) {
      var on = sw.getAttribute('data-value') === value;
      sw.classList.toggle('is-active', on);
      sw.setAttribute('aria-checked', on ? 'true' : 'false');
      sw.tabIndex = on ? 0 : -1;
      if (on && hintEl) hintEl.textContent = sw.getAttribute('data-hint') || '';
    });
    if (currentEl) currentEl.textContent = labelOf(value);
  }

  var tierImgs = qsa('[data-gr-tier-img]', root).concat(qsa('[data-gr-sticky-img]', root));
  // The pack thumbnails and the sticky bar show the colour just picked in a
  // per-bra dropdown, from that colour's variant photo.
  function thumbFor(value) {
    if (!product || !product.variants || !colourPos) return;
    var v = product.variants.filter(function (x) { return x.options[colourPos - 1] === value && x.featured_image; })[0];
    if (!v) return;
    var src = v.featured_image.src;
    src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120&height=120&crop=top';
    tierImgs.forEach(function (t) { t.src = src; });
  }
  function showPhoto(value, move) {
    var sw = swatches.filter(function (s) { return s.getAttribute('data-value') === value; })[0];
    var pos = sw ? parseInt(sw.getAttribute('data-slide'), 10) : NaN;
    var img = sw ? qs('.grcolour__img img', sw) : null;
    if (img) {
      // Pack thumbnails and the sticky bar show the colour being bought.
      var src = img.getAttribute('src');
      tierImgs.forEach(function (t) { t.src = src; });
    }
    if (!move || isNaN(pos) || typeof window.LovelleShowSlide !== 'function') return;
    window.LovelleShowSlide(pos - 1);
    var thumbs = qs('.brapdp__thumbs', root);
    if (thumbs && pos > 4) thumbs.classList.remove('is-collapsed');
  }

  function setAllColours(value, photo) {
    globalColour = value;
    selects.forEach(function (sel) {
      if (sel.__bra) sel.__bra.set(value, true); else sel.value = value;
      paintRow(sel);
    });
    paintBlock(value);
    showPhoto(value, photo);
    summary();
  }

  swatches.forEach(function (sw, i) {
    sw.addEventListener('click', function () {
      if (sw.getAttribute('data-oos') === 'true') return;
      setAllColours(sw.getAttribute('data-value'), true);
    });
    sw.addEventListener('keydown', function (e) {
      var step = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
      if (!step) return;
      e.preventDefault();
      var next = swatches[(i + step + swatches.length) % swatches.length];
      next.focus();
      next.click();
    });
  });

  /* ---- 2: the size block ---- */
  var sizeBlock = qs('[data-gr-size]', root);
  var bandBtns = sizeBlock ? qsa('[data-gr-band]', sizeBlock) : [];
  var cupBtns = sizeBlock ? qsa('[data-gr-cup]', sizeBlock) : [];
  var sizeCurrent = sizeBlock ? qs('[data-gr-size-current]', sizeBlock) : null;
  var sizeNeed = sizeBlock ? qs('[data-gr-size-need]', sizeBlock) : null;
  var band = null, cup = null, size = null;
  var sizeValues = product && product.options && product.options[1] ? (product.options[1].values || []) : [];
  // product.options in the product JSON is a list of names; values come from the variants.
  if (!sizeValues.length && product && product.variants) {
    product.variants.forEach(function (v) { var s = v.options[1]; if (s && sizeValues.indexOf(s) < 0) sizeValues.push(s); });
  }

  function paintSize() {
    bandBtns.forEach(function (b) {
      var on = b.getAttribute('data-value') === band;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    cupBtns.forEach(function (b) {
      var on = b.getAttribute('data-value') === cup;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      // A cup that does not exist with the chosen band is marked, not hidden.
      var exists = !band || sizeValues.indexOf(band + b.getAttribute('data-value')) > -1;
      b.toggleAttribute('data-oos', !exists);
    });
    if (sizeCurrent) {
      var text = size || (band ? band + ' –' : (sizeCurrent.getAttribute('data-empty') || ''));
      sizeCurrent.textContent = text;
      sizeCurrent.classList.toggle('is-empty', !size);
      if (size) { sizeCurrent.classList.remove('is-new'); void sizeCurrent.offsetWidth; sizeCurrent.classList.add('is-new'); }
    }
    if (sizeBlock) sizeBlock.classList.toggle('is-done', !!size);
    if (size && sizeNeed) sizeNeed.hidden = true;
  }

  function commitSize() {
    size = (band && cup && sizeValues.indexOf(band + cup) > -1) ? band + cup : null;
    paintSize();
    if (!size) { summary(); return; }
    if (mix && mix.checked) {
      // Mixing: the size above still fills every row, the rows stay open.
      sizeSelects.forEach(function (sel) { if (sel.__bra) sel.__bra.set(size, true); else sel.value = size; });
    } else if (typeof window.LovelleBraSetSize === 'function') {
      window.LovelleBraSetSize(size);
    }
    summary();
  }

  bandBtns.forEach(function (b) {
    b.addEventListener('click', function () { band = b.getAttribute('data-value'); commitSize(); });
  });
  cupBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.hasAttribute('data-oos')) return;
      cup = b.getAttribute('data-value'); commitSize();
    });
  });
  [bandBtns, cupBtns].forEach(function (group) {
    group.forEach(function (b, i) {
      b.addEventListener('keydown', function (e) {
        var step = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
        if (!step) return;
        e.preventDefault();
        var next = group[(i + step + group.length) % group.length];
        next.focus();
        next.click();
      });
    });
  });
  window.GraceSetSize = function (b, c) { band = String(b); cup = String(c).toUpperCase(); commitSize(); };

  function askForSize() {
    if (sizeNeed) sizeNeed.hidden = false;
    scrollToEl(sizeBlock);
    flash(sizeBlock);
    var first = qs('[data-gr-band].is-active', sizeBlock) ? qs('[data-gr-cup]', sizeBlock) : qs('[data-gr-band]', sizeBlock);
    if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, reduced ? 0 : 450);
  }
  function sizeReady() {
    if (!sizeBlock) return true;
    if (mix && mix.checked && rowSizesTouched) return true;
    return !!size;
  }

  // Before bra.js sees the click: no size yet means ask for one, not guess.
  var addBtn = qs('[data-bra-add]', bundle);
  bundle.addEventListener('click', function (e) {
    var hit = e.target && e.target.closest ? e.target.closest('[data-bra-add]') : null;
    if (!hit || sizeReady()) return;
    e.preventDefault();
    e.stopPropagation();
    askForSize();
  }, true);

  /* ---- 3: different colours or sizes ---- */
  var rowSizesTouched = false;
  if (mix) {
    mix.addEventListener('change', function () {
      bundle.classList.toggle('is-mixing', mix.checked);
      if (!mix.checked) {
        rowSizesTouched = false;
        // bra.js has put the rows back on its own last size; put them on ours.
        if (size && typeof window.LovelleBraSetSize === 'function') window.LovelleBraSetSize(size);
      } else if (size) {
        sizeSelects.forEach(function (sel) { if (sel.__bra) sel.__bra.set(size, true); else sel.value = size; });
      }
      summary();
    });
  }

  /* ---- 4: the receipt line above the button ---- */
  var summaryEl = qs('[data-gr-summary]', bundle);
  function summary() {
    if (!summaryEl) return;
    var current = qs('input[data-bra-tier]:checked', bundle);
    var box = current ? current.closest('[data-bra-tier-box]') : null;
    var picks = box ? qsa('[data-bra-pick]', box) : [];
    var n = current ? (parseInt(current.getAttribute('data-qty'), 10) || 1) : 1;
    var mixing = mix && mix.checked;
    var sizes = [], counts = {}, order = [];
    picks.forEach(function (pick) {
      var c = qs('[data-bra-color]', pick);
      var s = qs('[data-bra-size]', pick);
      var sv = mixing && rowSizesTouched && s ? s.value : size;
      if (sv && sizes.indexOf(sv) < 0) sizes.push(sv);
      if (c) {
        if (!counts[c.value]) { counts[c.value] = 0; order.push(c.value); }
        counts[c.value]++;
      }
    });
    if (!sizes.length) { summaryEl.hidden = true; return; }
    var text = (summaryEl.getAttribute('data-template') || '').replace('%n', n).replace('%s', sizes.join(', '));
    if (order.length) text += ' · ' + order.map(function (k) { return counts[k] + '× ' + labelOf(k); }).join(', ');
    summaryEl.textContent = text;
    summaryEl.hidden = false;
  }

  bundle.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('select[data-bra-color]')) { paintRow(t); thumbFor(t.value); summary(); return; }
    if (t.matches('select[data-bra-size]')) { rowSizesTouched = true; if (sizeNeed) sizeNeed.hidden = true; summary(); return; }
    if (t.matches('input[data-bra-tier]')) { paintSticky(t, true); bump(qs('[data-bra-total]', bundle)); summary(); }
  });

  /* ---- 5: the sticky bar ---- */
  var sticky = qs('[data-gr-sticky]', root);
  var stickyName = sticky ? qs('[data-gr-sticky-name]', sticky) : null;
  var stickyTotal = sticky ? qs('[data-gr-sticky-total]', sticky) : null;
  var stickyBuy = sticky ? qs('[data-gr-sticky-buy]', sticky) : null;

  function bump(el) {
    if (!el || reduced) return;
    var host = el.closest('.brabundle__add') || el;
    host.classList.remove('is-bump');
    void host.offsetWidth;
    host.classList.add('is-bump');
  }
  function paintSticky(input, animate) {
    if (!input) return;
    if (stickyName) stickyName.textContent = input.getAttribute('data-name') || stickyName.textContent;
    if (stickyTotal) {
      stickyTotal.textContent = input.getAttribute('data-total') || stickyTotal.textContent;
      if (animate) bump(stickyTotal);
    }
  }
  paintSticky(qs('input[data-bra-tier]:checked', bundle), false);

  if (stickyBuy) {
    stickyBuy.addEventListener('click', function () {
      if (!sizeReady()) { askForSize(); return; }
      if (addBtn) addBtn.click();
    });
  }

  /* ---- 7: "pick this colour" cards ---- */
  qsa('[data-gr-pick-colour]').forEach(function (b) {
    b.addEventListener('click', function () {
      var value = b.getAttribute('data-value');
      if (!value) return;
      setAllColours(value, true);
      thumbFor(value);
      scrollToEl(block || bundle);
      flash(block);
    });
  });

  // Start on the preselected colour, or the first one that can be bought.
  if (swatches.length) {
    var start = (swatches.filter(function (s) { return s.classList.contains('is-active'); })[0] || swatches[0]);
    if (start.getAttribute('data-oos') === 'true') {
      start = swatches.filter(function (s) { return s.getAttribute('data-oos') !== 'true'; })[0] || start;
    }
    setAllColours(start.getAttribute('data-value'), false);
  }
  paintSize();
  if (selects[0]) thumbFor(selects[0].value);
})();
